import { Tractor, Sprout, MonitorSmartphone, Satellite, RadioTower, Navigation, Gauge, Activity, Wrench } from "lucide-react";

const SINAIS = ["RTK", "RTX", "SF1", "SF2", "SF3", "WAAS/EGNOS", "Glide", "Outro"].map((v) => ({ value: v, label: v }));
const GPS_FIELDS = ["marca", "modelo", "numero_serie", "s.tela", "s.antena_receptor", "s.controlador", "s.versao_software", "s.tipo_sinal"];

export const TIPOS = {
  trator: { label: "Trator", icon: Tractor, fields: ["marca", "modelo", "ano", "patrimonio", "numero_serie", "s.horimetro"] },
  plantadeira: { label: "Plantadeira", icon: Sprout, fields: ["marca", "modelo", "patrimonio", "numero_serie", "s.numero_linhas", "s.espacamento"] },
  monitor: { label: "Monitor de plantio", icon: MonitorSmartphone, fields: ["marca", "modelo|Modelo do monitor", "numero_serie", "s.sensores", "s.quantidade_sensores", "s.versao_software"] },
  gps: { label: "GPS", icon: Satellite, fields: GPS_FIELDS },
  antena: { label: "Antena/receptor", icon: RadioTower, fields: ["marca", "modelo", "numero_serie", "s.tipo_sinal", "s.versao_software"] },
  piloto: { label: "Piloto automático", icon: Navigation, fields: GPS_FIELDS },
  taxa_variavel: { label: "Taxa variável", icon: Gauge, fields: ["marca", "modelo", "numero_serie", "s.controlador", "s.versao_software"] },
  sensor: { label: "Sensores", icon: Activity, fields: ["marca", "modelo", "s.tipo_sensor", "s.quantidade"] },
  outro: { label: "Outro equipamento", icon: Wrench, fields: ["nome|Nome/descrição", "marca", "modelo", "patrimonio", "numero_serie"] },
};

export const FIELD_DEFS = {
  nome: { label: "Nome" }, marca: { label: "Marca" }, modelo: { label: "Modelo" }, ano: { label: "Ano", type: "number" },
  patrimonio: { label: "Patrimônio" }, numero_serie: { label: "Número de série" },
  "s.horimetro": { label: "Horímetro (h)", type: "number" }, "s.numero_linhas": { label: "Número de linhas", type: "number" },
  "s.espacamento": { label: "Espaçamento (cm)", type: "number" }, "s.sensores": { label: "Sensores" },
  "s.quantidade_sensores": { label: "Quantidade de sensores", type: "number" }, "s.versao_software": { label: "Versão do software" },
  "s.tela": { label: "Tela" }, "s.antena_receptor": { label: "Antena/receptor" }, "s.controlador": { label: "Controlador" },
  "s.tipo_sinal": { label: "Tipo de sinal", options: SINAIS }, "s.tipo_sensor": { label: "Tipo de sensor" },
  "s.quantidade": { label: "Quantidade", type: "number" },
};

export const parseField = (f) => {
  const [key, custom] = f.split("|");
  return { key, ...FIELD_DEFS[key], label: custom || FIELD_DEFS[key].label };
};

export const fieldValue = (eq, key) => (key.startsWith("s.") ? eq.specs?.[key.slice(2)] : eq[key]);

export const EQ_STATUS = { ativo: "Ativo", manutencao: "Em manutenção", inativo: "Inativo" };

export const HIST_TIPOS = {
  cadastro: "Cadastro", edicao: "Edição", vinculo: "Vínculo", os: "Ordem de serviço", manutencao: "Manutenção",
  revisao: "Revisão", instalacao: "Instalação", atualizacao_software: "Atualização de software",
  calibracao: "Calibração", observacao: "Observação",
};

export const UFS = "AC AL AP AM BA CE DF ES GO MA MT MS MG PA PB PR PE PI RJ RN RS RO RR SC SP SE TO".split(" ").map((v) => ({ value: v, label: v }));

export const tipoIcon = (t) => TIPOS[t]?.icon || Wrench;
